import { OrganizationsPage } from '@/pages/Organizations';
import { createFileRoute } from '@tanstack/react-router';

const RouteComponent = (): React.ReactNode => {
  return <OrganizationsPage />;
};

export const Route = createFileRoute('/_auth/organizations/')({
  component: RouteComponent,
  loader: () => ({ crumb: 'Organizations' }),
});
